// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Grid, Typography, Badge } from '@material-ui/core';
import { StringUtils } from '../../../../../common/utils';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  badge: {
    '& .MuiBadge-badge': {
      top: '16px',
      right: '-20px',
    },
  },
}));

function ActivityList(props) {
  const classes = useStyles();

  const { id, title, activities, renderActivity, emptyContent } = props;

  return (
    <Box id={id} className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className={classes.header} variant="h6">
            <Badge badgeContent={activities.length} color="primary" className={classes.badge}>
              {title}
            </Badge>
          </Typography>
        </Grid>
        {!_.isEmpty(activities) &&
          activities.map((activity, index) => {
            const activityId = StringUtils.makeId(id, `${index}`);
            return (
              <Grid key={activityId} item xs={12}>
                {renderActivity(activity, activityId)}
              </Grid>
            );
          })}
      </Grid>
      {_.isEmpty(activities) && emptyContent}
    </Box>
  );
}

ActivityList.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  activities: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderActivity: PropTypes.func.isRequired,
  emptyContent: PropTypes.node.isRequired,
};

export default ActivityList;
